export default "<div id=\"goldenLayoutContainer\" class=\"pt-3 pb-4\">\n    \n</div>";